// AboutSection.js
import React from 'react';
import './component.css'; 
import aboutImage from '../assets/logo/about.png'
import whyImage from '../assets/logo/why.png'
import determineImage from '../assets/logo/determine.png'
import admissionImage from '../assets/logo/admission.png'
import { Link } from 'react-router-dom'; 





export const DepartmentSection = () => {
    return (
        <section className="about_section">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="about_img-container">
                            <img src={aboutImage} alt="About" />
                        </div>
                    </div>
                    <div className="col-md-6"  style={{ paddingRight: 0 }}>
                        <div className="detail-box">
                            <h2>विभाग के दायित्व</h2>
                            <p>मध्यप्रदेश शासन, द्वारा कार्य आवंटन नियम में जनजाति कल्याण विभाग को निम्नानुसार दायित्व सौंपे गये हैं</p>
                  <ul>
                    <li>जनजाति क्षेत्रों में समाज सेवाओं का समन्वय एकीकृत जनजाति विकास कार्यक्रम तथा जनजाति परियोजनाएं जनजाति उप आयोजना का अवधारण तथा अनुमान जनजाति क्षेत्र विकास योजना एवं अनुसंधान जनजातियों के समग्र विकास हेतु योजनाऐं </li>
                    <li>नीति निर्धारण एवं कार्यक्रमों का क्रियान्वयन ऐसे सेवाओं से संबद्ध सभी विषय जिनका विभाग से संबंध हो (वित्त विभाग और सामान्य प्रशासन विभाग को आवंटित किये गये विषयों को छोड़कर) उदाहरणार्थ पदस्थापना, स्थानांतरण, वेतन, छुट्टी, सेवानिवृत्ति वेतन, पदोन्नतियां, भविष्य निधि, प्रतिनियुक्तियों, दण्ड तथा अभ्यावेदन संविधान की पांचवी अनुसूची के अधिकारों और जनजातीय क्षेत्र के हितों के संरक्षण व संवर्धन के लिये प्रहरी के रूप में कार्य करना। </li>
                    <li> क्षेत्र - जनजाति मंत्रणा परिषद जनजाति बाहुल क्षेत्रों के विकास हेतु प्राथमिकताओं का निर्धारण कराने हेतु आदिवासी उपयोजना कार्यक्रमों के क्रियान्वयन हेतु विभिन्न विकास विभागों को बजट उपलब्ध कराने हेतु नोडल एजेन्सी के रूप में कार्य करना एंवं अनुश्रवण करना जनजाति के शैक्षणिक/सामाजिक एवं आर्थिक उत्थान हेतु विभिन्न कार्यक्रमों का क्रियान्वयन संदेहास्पद जनजाति प्रमाण पत्र की जांच करना विशेष पिछडी जनजाति समूह के विकास हेतु नीति निर्धारण एवं योजनाओं का क्रियान्वयन विशेष केन्द्रीय सहायता से संचालित योजनाओं का नियोजन एवं अनुश्रवण संविधान के अनुच्छेद 275(1)के अंतर्गत प्राप्त केन्द्रीय सहायता अंतर्गत योजनाओं की स्वीकृति एवं अनुश्रवण जनजातीयों में तकनीकी एवं गुणात्मक शिक्षा का विकास जनजातीयों की सामाजिक सुरक्षा एवं शोषण से बचाव आदिवासी उपयोजना की राशि के संबंध में नोडल विभाग के रूप में अन्य विकास विभागों से समन्वय। </li>
                    <li>आदिवासी उपयोजना क्षेत्र में विभिन्न विभागों के द्वितीय एवं तृतीय श्रेणी कार्यपालिक अधिकारियों का प्रशिक्षण। जनजातीयों का हित संरक्षण।</li>
                  </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

// TCfireSection.js
export const TCSection = () => {
    return (
        <section className="admission_section">
            <div className="container">
                <div className="row">
                <div className="col-md-6">
                        <div className="detail-box">
                            <h2>ट्रांसफर सर्टिफिकेट सेक्शन</h2>
                            <p>यहाँ आपको ट्रांसफर सर्टिफिकेट के लिए आवेदन करने और प्राप्त करने की प्रक्रिया के संबंधित महत्वपूर्ण जानकारी मिलेगी। अपने ट्रांसफर सर्टिफिकेट के आवेदन की प्रक्रिया को आसान और सुविधाजनक बनाने के लिए, हम आपके लिए यहाँ एक व्यापक जानकारी स्रोत प्रदान कर रहे हैं:</p>
                            <ul>
                                <li>ट्रांसफर सर्टिफिकेट जारी करने के लिए आवश्यक दस्तावेजों के बारे में विस्तृत जानकारी प्रदान की गई है, जिससे आवश्यक दस्तावेजों को तैयार करने और सबमिट करने में मदद मिलती है।</li>
                                <li>आवेदनकर्ताओं के सामान्य सवालों के उत्तर देने वाला विस्तारित FAQ खंड उपलब्ध है। इसके अलावा, ट्रांसफर सर्टिफिकेट प्रक्रिया को बेहतर समझने में मदद करने वाले विस्तारित दिशानिर्देश भी उपलब्ध हैं।</li>
                            </ul>
                            <Link to="/tc">
                                <button className="call_to-btn btn_white-border" target="_blank" rel="noopener noreferrer">ट्रांसफर सर्टिफिकेट सेक्शन में जाएं</button>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="admission_img-container">
                            <img src={admissionImage} alt="Admission" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export const AboutSection = () => {
    return (
        <section className="about_section">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="about_img-container">
                            <img src={aboutImage} alt="About" />
                        </div>
                    </div>
                    <div className="col-md-6">
                    
                        <div className="detail-box">
                        <h2>उद्देश्य</h2>
                            
                            <p>कन्या शिक्षा परिसर बीजाडांडी का उद्देश्य अनुसूचित जनजाति (एसटी) की छात्राओं को दूरस्थ क्षेत्रों में मध्य और उच्च स्तरीय गुणवत्ता वाली शिक्षा प्रदान करना है, न केवल उन्हें उच्च और पेशेवर शैक्षणिक पाठ्यक्रमों में आरक्षण के लाभ उठाने की सुविधा प्रदान करके, बल्कि सरकारी और सार्वजनिक और निजी क्षेत्रों में नौकरियों में भी, बल्कि गैर एसटी आबादी के साथी शिक्षा के सर्वोत्तम अवसरों का पहुंच प्राप्त करने की भी। इसे निम्नलिखित द्वारा प्राप्त किया जाएगा:</p>
                  <ul>
                    <li>हर केएसपी बीजाडांडी  में नामांकित सभी छात्राओं के समग्र शारीरिक, मानसिक और सामाजिक उपयुक्त विकास का समर्थन करना। छात्रा बदलाव का अधिकारी बनाए जाएंगे, अपने स्कूल, अपने घरों, अपने गांवों में और अंत में एक बड़े संदर्भ में।</li>
                    <li>छठे से दसवीं कक्षा तक वालों के लिए उपलब्ध कराई जाने वाली शिक्षाविद्यालयीन सहायता पर विशेष ध्यान केंद्रित करना, ताकि उनकी

                  विशेष आवश्यकताओं को पूरा किया जा सके।</li>
                    <li>छात्रा जीवन की शिक्षा, शारीरिक, पर्यावरणीय और सांस्कृतिक आवश्यकताओं को पूरा करने वाले भूमिका के अनुरूप बनाए जाने वाले अवसंरचना का समर्थन करना।</li>
                  </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

// AdmissionSection.js
export const AdmissionSection = () => {
    return (
        <section className="admission_section">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                    
                        <div className="detail-box">
                        <h2>प्रवेश</h2>
                            
                            <p> हमें खुशी है यह सूचित करने में कि हमारे संस्थान में प्रवेश खुल चुके हैं। आपके बच्चे को एक प्रशिक्षित, सुरक्षित और उच्चतम गुणवत्ता वाली शिक्षा का अवसर प्रदान करें। हमारे साथ जुड़ें और उन्नति की ओर एक कदम बढ़ाएं। आवेदन करें और अपने बच्चे के भविष्य को सुरक्षित करें।</p>
                            <a href="https://www.tribal.mp.gov.in/mptaasschool/SchoolStudent/PreExamRegistration/MPSARASRegistration" className="call_to-btn btn_white-border" target="_blank" rel="noopener noreferrer">
                                visit us
                            </a>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="admission_img-container">
                            <img src={admissionImage} alt="Admission" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

// WhySection.js
export const WhySection = () => {
    return (
        <section className="why_section">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="why_img-container">
                            <img src={whyImage} alt="Why Choose Us" />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="detail-box">
                        <h2>
              कन्या शिक्षा परिसर बीजाडांडी में क्यों सीखें  
              </h2>
              <p>
                KSP बीजाडांडी  में सीखना एक अद्वितीय और प्रभावी अनुभव होता है। हमारा संस्थान एक उच्चतम गुणवत्ता वाली शिक्षा प्रदान करने के लिए प्रतिबद्ध है और विद्यार्थियों को एक स्नातक स्तर की तकनीकी, प्रबंधन और व्यावसायिक शिक्षा का अद्यतन और समर्पित संकल्प देता है। हम अद्यतित पाठ्यक्रम, प्रशिक्षण और अधिकृत शिक्षकों के माध्यम से विद्यार्थियों के अभिवृद्धि को प्रोत्साहित करते हैं।

KSP बीजाडांडी  एक सुरक्षित, सहज और प्रेरणादायक शिक्षा माहौल प्रदान करता है, जहां छात्राओं का समृद्ध विकास ध्यान केंद्रित होता है। हम संगठनात्मक गतिविधियों, कला और सांस्कृतिक कार्यक्रमों के माध्यम से छात्राओं की व्यक्तिगत विकास को बढ़ावा देते हैं। हम शिक्षा के क्षेत्र में सशक्त साझेदारियों के साथ मिलकर स्वर्गीय अवसरों को उघाड़ने के लिए प्रतिबद्ध हैं।
              </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

// DetermineSection.js
export const DetermineSection = () => {
    return (
        <section className="determine_section">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="detail-box">
                        <h2>
              कन्या शिक्षा परिस के उद्देश्य
              </h2>
              <p>
कन्या शिक्षा परिसर का मुख्य उद्देश्य दूरदराज के क्षेत्रों में अनुसूचित जनजाति (ST) के छात्राओं को मध्यम और उच्च स्तरीय गुणवत्तापूर्ण शिक्षा प्रदान करना है, न केवल उन्हें उच्च और पेशेवर शिक्षा पाठ्यक्रमों में आरक्षण का लाभ उठाने में सक्षम बनाने के लिए, बल्कि सरकारी और सार्वजनिक और निजी क्षेत्रों में नौकरियों के लिए भी, साथ ही गैर-ST आबादी के समान शिक्षा में सर्वोत्तम अवसरों तक पहुँच प्रदान करने के लिए। इसे प्राप्त किया जाएगा:

- हर एक कन्या शिक्षा परिसर में नामांकित सभी छात्राओं का समग्र शारीरिक, मानसिक, और सामाजिक रूप से प्रासंगिक विकास। छात्राओं को अपने स्कूल, अपने घरों, अपने गाँव और अंततः एक बड़े संदर्भ में परिवर्तन एजेंट बनने के लिए सशक्त बनाया जाएगा।
- शैक्षिक समर्थन पर विशेष ध्यान देना जो कक्षा VI से XII तक के छात्राओं को उपलब्ध कराया जाना है, ताकि उनकी विशिष्ट आवश्यकताओं को पूरा किया जा सके,
- उस बुनियादी ढांचे के निर्माण का समर्थन करना जो छात्रा जीवन की शिक्षा, शारीरिक, पर्यावरणीय और सांस्कृतिक आवश्यकताओं को प्रदान करता है।          </p>
            
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="determine_img-container">
                            <img src={determineImage} alt="Our Goals" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

